import React, { useEffect, useMemo, useState } from "react";
import Layout from '../../components/layoutConfig/layout';
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "animate.css";
import { setupAPIclient } from '../../services/setupAPIclient';
import LocalStorage from '../../helpers/localstorage';
import DataTable, { TableColumn } from "react-data-table-component";
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Select, { components, OptionProps, MultiValueGenericProps, StylesConfig } from "react-select";
import LayoutSubmasterToUser from "../../components/layoutConfig/layoutSubmasterToUser";

/* ---------------------- Types ---------------------- */

interface Location {
  id: number;
  name: string;
  unit_id?: number;
  unitName?: string;
  companyName?: string;
  regionName?: string;
}

interface History {
  id: number;
  data_vencimento: string;
  created_at?: string;
  caminho_doc?: string;
}

interface Reminder {
  id: number;
  message: string;
  reminder_days: number;
  sms: boolean;
  whatts: boolean;
  email: boolean;
}

interface UserAccess {
  id: number;
  user_id: number;
  name: string;
  email: string;
  phone?: string;
  can_view?: boolean;
}

interface ContractData {
  id: number;
  name?: string;
  caminho_doc?: string;
  data_vencimento?: string;
  created_at?: string;
  classification: string;
  updated_at?: string;
  history?: History[];
  locations?: Location[];
  reminders?: Reminder[];
  users_access?: UserAccess[];
  signatories?: Signatory[]; // opcional
}

interface FormLocal {
  id: number;
  unit_id: number | null;
  unitName: string;
  name: string;
}

interface Signatory {
  id?: number;
  email: string;
  user_id?: number | null;
}

interface ApiUser {
  id: number;
  email: string;
  name: string;
  number_phone?: string;
  created_at?: string;
  updated_at?: string;
  can_view?: boolean;
  typeofcontract: string;
}

interface ApiCompany {
  company_id: number;
  name_company: string;
  region_id?: number;
  region_name?: string;
  unit_id?: number;
  unit_name?: string;
  location_id?: number;
  location_name?: string;
}

interface Notification {
  id: number;
  mensage: string;
  sms: boolean;
  email: boolean;
  a_message?: boolean;
  created_at?: string;
  updated_at?: string;
}

/* ---------------------- Component ---------------------- */

export default function SeeContractPageSubmaster() {
  const localStorage = new LocalStorage();
  const token = String(localStorage.getAuthTokenUserToSubmaster());
  const ApiClient = setupAPIclient(token);

  const [sms, setSms] = useState(false);
  const [whats, setWhats] = useState(false);
  const [email, setEmail] = useState(true);

  const [contracts, setContracts] = useState<ContractData[]>([]);
  const [filteredContracts, setFilteredContracts] = useState<ContractData[]>([]);
  const [loading, setLoading] = useState(true);

  const [users, setUsers] = useState<ApiUser[]>([]);
  const [companies, setCompanies] = useState<ApiCompany[]>([]);

  const [filterId, setFilterId] = useState("");
  const [filterLocation, setFilterLocation] = useState("");
  const [filterDate, setFilterDate] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [selectedContract, setSelectedContract] = useState<ContractData | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const [signatories, setSignatories] = useState<Signatory[]>([{ email: "" }]);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [message, setMessage] = useState("");
  const [data, setData] = useState<FormLocal[]>([]);
  const [dueDate, setDueDate] = useState("");
  const [pendingUnits, setPendingUnits] = useState(true);

  const [selectedCompany, setSelectedCompany] = useState<number | null>(null);
  const [selectedRegion, setSelectedRegion] = useState<number | null>(null);
  const [selectedUnit, setSelectedUnit] = useState<number | null>(null);
  const [selectedLocation, setSelectedLocation] = useState<number | null>(null);

  const [reminderDays,setReminderDays] =  useState<number | null>(0);

  const [notification, setNotification] = useState<Notification | null>(null);

  const [classification, setClassification] = useState<string>("");


    // Configuração das opções para react-select (usado no Select multi)
  const userOptions: ApiUser[] = users.map(u => ({
    value: u.id,
    label: `${u.name} (${u.email})`,
    name: u.name,
    email: u.email,
    typeofcontract: u.typeofcontract || ""
  }));
  // classification options
  const classificationOptions = [
    "Locação",
    "Prestação de Serviço",
    "Compra e Venda",
    "Parceria / Colaboração",
    "Fornecimento",
    "Trabalho / RH",
    "Licenciamento / Tecnologia"
  ];

  // Buscar notificação existente
  const handleGetNotification = async (): Promise<Notification | null> => {
    try {
      const response = await ApiClient.post("/management/get/notification");
      const payload = response.data?.success ?? response.data ?? null;
      if (Array.isArray(payload) && payload.length > 0) {
        const n = payload[0] as Notification;
        setNotification(n);
        return n;
      }
      if (payload && !Array.isArray(payload)) {
        const n = payload as Notification;
        setNotification(n);
        return n;
      }
      return null;
    } catch (err) {
      console.error("Erro ao buscar notificação:", err);
      return null;
    }
  };


  /* ---------------------- Utilitários ---------------------- */

  const formatDateBR = (dateStr?: string | null) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) {
      try {
        const parts = (dateStr || "").split("-");
        if (parts.length >= 3) {
          const [y, m, day] = parts;
          return `${day.padStart(2,"0")}/${m.padStart(2,"0")}/${y}`;
        }
      } catch { return dateStr; }
    }
    return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
  };

  const isPast = (dateStr?: string | null) => {
    if (!dateStr) return false;
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return false;
    const today = new Date();
    today.setHours(0,0,0,0);
    const cmp = new Date(d);
    cmp.setHours(0,0,0,0);
    return cmp < today;
  };

  const initialsFromEmail = (email: string) => {
    if (!email) return "?";
    const name = email.split("@")[0];
    const parts = name.split(/\.[\-_]/).filter(Boolean);
    if (parts.length === 0) return name.slice(0,2).toUpperCase();
    if (parts.length === 1) return parts[0].slice(0,2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

   // estilos do react-select para ficar mais compacto
    const selectStyles: StylesConfig<ApiUser, true> = {
      control: (provided) => ({ ...provided, minHeight: 44 }),
      valueContainer: (provided) => ({ ...provided, padding: "4px 8px" }),
      multiValue: (provided) => ({ ...provided, background: "#eef5ff" }),
      option: (provided) => ({ ...provided, padding: 0 })
    };
  
  // custom MultiValue (aparece acima quando selecionado — podemos mostrar só o nome e um badge pequeno)
  const CustomMultiValue = (props: MultiValueGenericProps<ApiUser>) => {
    const contractType = props.data.typeofcontract || "";
    const badgeStyle: React.CSSProperties = {
      marginLeft: 6,
      padding: "1px 6px",
      borderRadius: 10,
      fontSize: 11,
      fontWeight: 700,
      lineHeight: "14px",
      color: "#fff",
      background: contractType.toLowerCase().includes("contratada") ? "#8e44ad" : "#2980b9"
    };
    return (
      <components.MultiValue {...props}>
        <span style={{ fontWeight: 600 }}>{props.data.name}</span>
        <span style={badgeStyle}>{contractType}</span>
      </components.MultiValue>
    );
  };

    // custom render para Option (duas linhas, com destaque para typeofcontract)
    const CustomOption = (props: OptionProps<ApiUser, true>) => {
      const { data, innerRef, innerProps, isFocused, isSelected } = props;
      const contractType = data.typeofcontract || "";
      const badgeStyle: React.CSSProperties = {
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: "16px",
        marginTop: 6
      };
      // cores por tipo
      const color = contractType.toLowerCase().includes("contratada")
        ? "#8e44ad" // roxo
        : "#2980b9"; // azul para 'Contratado' ou default
  
      return (
        <div
          ref={innerRef}
          {...innerProps}
          style={{
            padding: "8px 12px",
            background: isFocused ? "#f5f7fb" : "white",
            display: "flex",
            flexDirection: "column",
            borderLeft: isSelected ? `4px solid ${color}` : undefined
          }}
        >
          <div style={{ fontWeight: 600 }}>{data.name} <span style={{ fontWeight: 400, color: "#666" }}>({data.email})</span></div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ ...badgeStyle, background: `${color}20`, color }}>{contractType}</div>
            <div style={{ fontSize: 12, color: "#777" }}>{/* espaço para info adicional se desejar */}</div>
          </div>
        </div>
      );
    };
  
  /* ---------------------- Fetchers ---------------------- */

  useEffect(() => {
    fetchContracts();
    fetchLocation();
    fetchUsers();
    fetchCompanies();
  }, []);

  const fetchContracts = async () => {
    setLoading(true);
    try {
      const res = await ApiClient.post("/management/get/uploaddoc");
      const payload = res.data?.data ?? res.data?.success ?? [];
      const mappedContracts: ContractData[] = (payload || []).map((contract: any) => ({
        ...contract,
        caminho_doc: contract.caminho_doc || contract.caminho || contract.path || contract.caminho_doc,
        history: (contract.history || contract.histories || contract.docs || []).map((h: any) => ({
          id: h.id,
          data_vencimento: h.data_vencimento || h.date || "",
          created_at: h.created_at || h.createdAt || undefined,
          caminho_doc: h.caminho_doc || h.path || h.caminho
        })),
        locations: (contract.access?.map((a: any) => ({
          id: a.location?.id || a.location_id || 0,
          name: a.location?.name || a.location_name || "-",
          unit_id: a.unit?.id || a.unit_id || 0,
          unitName: a.unit?.name || a.unit_name || "-",
          companyName: a.company?.name_company || a.company?.name_company || a.company_name || "-",
          regionName: a.region?.name || a.region_name || "-"
        })) ?? contract.locations) || [],
        reminders: contract.reminders,
        users_access: contract.users_access || contract.users || []
      }));


      
      setContracts(mappedContracts);
      setFilteredContracts(mappedContracts);
    } catch (err) {
      console.error("Erro ao buscar contratos:", err);
      toast.error("❌ Erro ao buscar contratos");
    } finally {
      setLoading(false);
    }
  };

  const fetchLocation = async () => {
    try {
      const response = await ApiClient.post("/management/get/location");
      const payload = response.data?.data ?? response.data ?? [];
      const allLocals: FormLocal[] = (payload || []).map((item: any) => ({
        id: item.id,
        unit_id: item.management_unit?.id ?? item.unit_id ?? null,
        unitName: item.management_unit?.name ?? item.unit_name ?? "",
        name: item.name ?? item.location_name ?? ""
      }));
      setData(allLocals);
      setPendingUnits(false);
    } catch (err) {
      console.error("Erro ao carregar unidades:", err);
      toast.error("Erro ao carregar unidades");
      setPendingUnits(false);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await ApiClient.post("/management/get/users");
      const payload = response.data?.success ?? response.data ?? [];
      setUsers(payload as ApiUser[]);
    } catch (err) {
      console.error("Erro ao buscar usuários:", err);
      toast.error("Erro ao carregar usuários");
    }
  };

  const fetchCompanies = async () => {
    try {
      const response = await ApiClient.post("/management/get/company");
      const payload = response.data?.success ?? response.data ?? [];
      setCompanies(payload as ApiCompany[]);
    } catch (err) {
      console.error("Erro ao buscar empresas:", err);
      toast.error("Erro ao carregar empresas");
    }
  };

  /* ---------------------- Filters ---------------------- */

  useEffect(() => {
    let temp = [...contracts];
    if (filterId.trim()) temp = temp.filter(c => c.id.toString().includes(filterId.trim()));
    if (filterLocation.trim()) {
      temp = temp.filter(c => (c.locations || []).some(l => (l.name || "").toLowerCase().includes(filterLocation.toLowerCase())));
    }
    if (filterDate) {
      temp = temp.filter(c => {
        if (!c.data_vencimento) return false;

        const parseDate = (dateStr) => {
          // Garante que o formato seja dd/mm/yyyy
          const parts = dateStr.split('/');
          if (parts.length === 3) {
            const [day, month, year] = parts.map(p => parseInt(p, 10));
            return new Date(year, month - 1, day); // <-- Mês começa em 0 no JS
          }
          // Caso venha em outro formato (ex: yyyy-mm-dd)
          return new Date(dateStr);
        };

        const d1 = parseDate(c.data_vencimento);
        const d2 = parseDate(filterDate);

        if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
          return c.data_vencimento.startsWith(filterDate);
        }

        d1.setHours(0, 0, 0, 0);
        d2.setHours(0, 0, 0, 0);

        return d1.getTime() === d2.getTime();
      });

    }
    setFilteredContracts(temp);
  }, [filterId, filterLocation, filterDate, contracts]);

  /* ---------------------- Modal & Form ---------------------- */

const openModal = async (contract: ContractData) => {


  setClassification(contract.classification)

  // Faz uma cópia do contrato para evitar mutações diretas
  const copy = { ...contract } as ContractData;

  // Garante preview
  setPreviewUrl(copy.caminho_doc ? `https://alexios.com.br:9598/${copy.caminho_doc}` : null);

  // Signatários
  const initialSignatories: Signatory[] =  (copy.users_access && copy.users_access.length)
  ? copy.users_access.map(u => ({ id: u.id, email: u.email, user_id: u.user_id ?? u.id }))
  : [{ email: "" }];
  setSignatories(initialSignatories.length ? initialSignatories : [{ email: "" }]);

  // Vencimento
  setDueDate(copy.data_vencimento ? copy.data_vencimento.split("T")[0] : "");

  // Busca notificação global e usa como fallback (se existir)
  const notif = await handleGetNotification();

  // Lembretes -> prioriza o que já vem no contrato, senão usa notificação global
  if (copy.reminders?.[0]) {
    setEmail(Boolean(copy.reminders?.[0]?.email));
    setSms(Boolean(copy.reminders?.[0]?.sms));
    setWhats(Boolean(copy.reminders[0].whatts));
    setMessage(copy.reminders[0].message || "");
    setReminderDays(Number(copy.reminders?.[0].reminder_days ?? 0));
  } else if (notif) {
    setEmail(Boolean(notif.email));
    setSms(Boolean(notif.sms));
    setWhats(Boolean(notif.a_message));
    setMessage(notif.mensage || "");
    setReminderDays(0);
  } else {
    setSms(false);
    setWhats(false);
    setEmail(true);
    setMessage("");
    setReminderDays(0);
  }

  // Preenche created_at do histórico quando faltar, usando created_at da notificação como fallback
  if (Array.isArray(copy.history)) {
    copy.history = copy.history.map(h => ({ ...h, created_at: h.created_at ?? notif?.created_at ?? undefined }));
  }

  // Seleção automática de empresa/região/unidade/local
  const firstLocation = copy.locations?.[0];
  setSelectedCompany(firstLocation?.companyName ? companies.find(c => c.name_company === firstLocation.companyName)?.company_id ?? null : null);
  setSelectedRegion(firstLocation?.regionName ? companies.find(c => c.region_name === firstLocation.regionName)?.region_id ?? null : null);
  setSelectedUnit(firstLocation?.unitName ? companies.find(c => c.unit_name === firstLocation.unitName)?.unit_id ?? null : null);
  setSelectedLocation(firstLocation?.id ?? null);

  setSelectedContract(copy);
  setShowModal(true); // mantém modal aberto
};


  const closeModal = () => {
    setShowModal(false);
    setSelectedContract(null);
    setSelectedFile(null);
    setPreviewUrl(null);
    setSignatories([{ email: "" }]);
    setDueDate("");
    setSelectedLocation(null);
    setMessage("");
    setSms(false);
    setWhats(false);
    setEmail(true);
    setNotification(null);
  };

  const handlePreviewHistory = (history: History) => {
    if (history.caminho_doc) setPreviewUrl(`https://alexios.com.br:9598/${history.caminho_doc}`);
    else toast.warning("Documento não disponível");
  };

  /* ---------------------- Signatários helpers ---------------------- */

  const handleSignatoryChange = (index: number, value: string) => {
    setSignatories(prev => {
      const list = [...prev];
      list[index] = { ...list[index], email: value, user_id: null };
      return list;
    });
  };

  const handleAddSignatory = () => setSignatories(prev => [...prev, { email: "" }]);

  const handleRemoveSignatory = async (index: number, id?: number) => {
    let removedItem: Signatory | null = null;
    setSignatories(prev => {
      const list = [...prev];
      removedItem = list.splice(index, 1)[0];
      return list;
    });

    if (!id) return;

    const toastId = toast.loading("Deletando email...");
    try {
      await ApiClient.post("/management/delete/sigantario", { id });
      toast.dismiss(toastId);
      toast.success("Email deletado com sucesso");
      fetchContracts();
    } catch (err) {
      console.error(err);
      toast.dismiss(toastId);
      toast.error("Erro ao deletar email");
      setSignatories(prev => {
        const restored = [...prev];
        restored.splice(index, 0, removedItem!);
        return restored;
      });
    }
  };

  const selectUserAsSignatory = (index: number, userId: number | null) => {
    const user = users.find(u => u.id === userId) ?? null;
    setSignatories(prev => {
      const list = [...prev];
      list[index] = { ...list[index], email: user ? user.email : "", user_id: user ? user.id : null };
      return list;
    });
  };

  /* ---------------------- File & Submit ---------------------- */

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
      setPreviewUrl(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!dueDate) return toast.error("⚠️ Preencha Local e Vencimento");

    // try {
      const form = new FormData();
      if (selectedFile) form.append("uploaddoc", selectedFile);
      form.append("data_vencimento", dueDate);
      form.append("user_id", JSON.stringify(signatories.filter(s => s.email !== "")));
      form.append("id", String(selectedContract?.id ?? ""));
      form.append("sms", String(sms));
      form.append("email", String(email));
      form.append("message", message || "");
      form.append("name", selectedContract?.name || "");
      form.append("reminderDays", String(reminderDays))

      if (selectedCompany) form.append("company_id", String(selectedCompany));
      if (selectedRegion) form.append("region_id", String(selectedRegion));
      if (selectedUnit) form.append("unit_id", String(selectedUnit));
      if (selectedLocation) form.append("location_id", String(selectedLocation));

      const res = await ApiClient.post("management/update/uploaddoc", form, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (res.data?.success) {
        toast.success("✅ Contrato atualizado com sucesso!");
        await fetchContracts();
        setSelectedFile(null);
        closeModal();
      } else {
        toast.error(res.data?.message || "Erro ao atualizar contrato");
      }
    /*} catch (err: any) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Erro ao atualizar contrato");
    }*/
  };

  /* ---------------------- Table columns ---------------------- */

  const SignatoriesStack: React.FC<{ signatories?: Signatory[] }> = ({ signatories = [] }) => {
    const visible = 3;
    const items = signatories.map(s => s.email || "");
    const visibleItems = items.slice(0, visible);
    const extra = Math.max(0, items.length - visible);
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ display: "flex", marginRight: 6 }}>
          {visibleItems.map((email, idx) => (
            <OverlayTrigger key={idx} placement="top" overlay={<Tooltip>{email}</Tooltip>}>
              <div style={{
                width: 32, height: 32, borderRadius: 999, display: "flex",
                alignItems: "center", justifyContent: "center", backgroundColor: "#0d6efd",
                color: "white", fontSize: 12, marginLeft: idx === 0 ? 0 : -10,
                border: "2px solid #fff", boxShadow: "0 1px 2px rgba(0,0,0,0.15)"
              }}>
                {initialsFromEmail(email)}
              </div>
            </OverlayTrigger>
          ))}
        </div>
        {extra > 0 && (
          <OverlayTrigger placement="top" overlay={<Tooltip>{items.slice(visible).join(", ")}</Tooltip>}>
            <div style={{
              marginLeft: 6, padding: "4px 8px", borderRadius: 20,
              backgroundColor: "#6c757d", color: "white", fontSize: 12
            }}>
              +{extra}
            </div>
          </OverlayTrigger>
        )}
        {items.length === 0 && <span className="text-muted">Nenhum</span>}
      </div>
    );
  };

  const columns: TableColumn<ContractData>[] = useMemo(() => {
    const renderBadge = (content: string | number, color: string) => (
      <span className={`badge bg-${color}`}>{content}</span>
    );

    const renderVencimento = (date?: string) => {
      if (!date) return renderBadge("-", "secondary"); // caso a data seja undefined

      let parsedDate: Date;

      // Detecta se é formato BR dd/mm/yyyy
      if (date.includes('/')) {
        const [day, month, year] = date.split('/').map(p => parseInt(p, 10));
        parsedDate = new Date(year, month - 1, day);
      } else if (date.includes('-')) {
        // Assume formato ISO yyyy-mm-dd
        const [year, month, day] = date.split('-').map(p => parseInt(p, 10));
        parsedDate = new Date(year, month - 1, day);
      } else {
        parsedDate = new Date(date); // outros formatos
      }

      if (isNaN(parsedDate.getTime())) {
        return renderBadge(date, "warning"); // data inválida
      }

      // Formata para dd/mm/yyyy
      const formatted = parsedDate.toLocaleDateString('pt-BR');

      // Verifica se a data já passou
      parsedDate.setHours(0, 0, 0, 0);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const past = parsedDate.getTime() < today.getTime();

      return renderBadge(formatted, past ? "danger" : "success");
    };



    const renderLocations = (locations?: Location[]) => (
      <span className="text-secondary">
        <i className="bi bi-building me-1"></i>
        {locations?.map(l => l.name).join(", ") || "-"}
      </span>
    );

    const getInitial = (text: string) => text.charAt(0).toUpperCase();

    const renderUsersAccess = (users?: UserAccess[]) => {
      if (!users || users.length === 0) return "-";
      return (
        <div style={{ display: "flex", gap: 4 }}>
          {users.map(u => (
            <OverlayTrigger key={u.id} placement="top" overlay={<Tooltip>{u.email}</Tooltip>}>
              <div className="d-flex justify-content-center align-items-center text-white" style={{
                width: 28, height: 28, borderRadius: "50%", backgroundColor: "#0d6efd",
                fontSize: "0.85rem", fontWeight: 600, cursor: "pointer",
              }}>
                {getInitial(u.email)}
              </div>
            </OverlayTrigger>
          ))}
        </div>
      );
    };

    const renderActions = (row: ContractData) => (

      
      
      <div className="d-flex gap-2">
        <OverlayTrigger placement="top" overlay={<Tooltip>Ver detalhes</Tooltip>}>
          <button className="btn btn-sm btn-outline-primary rounded-pill shadow-sm"                       style={{background:"#5dade2", color:"white"}}
 onClick={() => openModal(row)}>
            <i className="bi bi-eye"></i>
          </button>
        </OverlayTrigger>
        <OverlayTrigger placement="top" overlay={<Tooltip>Download</Tooltip>}>
          <a className="btn btn-sm btn-outline-secondary rounded-pill shadow-sm"
             href={row.caminho_doc ? `https://alexios.com.br:9598/${row.caminho_doc}` : "#"}
             target="_blank" rel="noreferrer">
            <i className="bi bi-download"></i>
          </a>
        </OverlayTrigger>
      </div>
    );

    return [
      { name: <span><i className="bi bi-hash text-primary"></i> ID</span>, selector: row => row.id, sortable: true,
         width: "80px", center: true, cell: row => renderBadge(row.id, "dark") },
      { name: <span><i className="bi bi-file-text text-primary"></i> Nome</span>, selector: row => row.name || "-", 
        sortable: true, wrap: true, cell: row => <span className="fw-bold text-dark">{row.name || "-"}</span> },
      { name: <span><i className="bi bi-calendar-event text-primary"></i> Vencimento</span>, 
        selector: row => row.data_vencimento, sortable: true, width: "150px", cell: row => renderVencimento(row.data_vencimento) },
      //{ name: <span><i className="bi bi-geo-alt text-primary"></i> Local</span>, selector: row => row.locations?.map(l => l.name).join(", ") || "-", sortable: true, wrap: true, cell: row => renderLocations(row.locations) },
      { name: <span><i className="bi bi-people text-primary"></i> Usuários com acesso</span>, 
        selector: row => row.users_access?.map(u => u.name).join(", ") || "-", wrap: true, grow: 2, 
        cell: row => renderUsersAccess(row.users_access) },
      { name: <span><i className="bi bi-lightning-charge text-primary"></i> Ações</span>, 
        cell: row => renderActions(row), ignoreRowClick: true, button: true, width: "140px" 
      },
    ];
  }, [users]);

  const customStyles = {
    headCells: { style: { fontWeight: "700", fontSize: "14px", backgroundColor: "#f8f9fa" } },
    rows: { highlightOnHoverStyle: { backgroundColor: "#f0f8ff", transition: "0.15s" } },
    cells: { style: { fontSize: "13px" } }
  };

  return (
    <LayoutSubmasterToUser>
      <div className="row py-4 animate__animated animate__fadeIn ml-2 mr-2">
        {/* filtros */}
        <div className="row mb-4 g-2 animate__animated animate__fadeInUp">
          <div className="col-md-2"><input className="form-control shadow-sm" placeholder="🔎 ID" value={filterId} onChange={e => setFilterId(e.target.value)} /></div>
          {/**          <div className="col-md-4"><input className="form-control shadow-sm" placeholder="🏢 Local" value={filterLocation} onChange={e => setFilterLocation(e.target.value)} /></div> */}
          <div className="col-md-2"><input type="date" className="form-control shadow-sm" value={filterDate} onChange={e => setFilterDate(e.target.value)} /></div>
        </div>

        {/* tabela */}
        <div className="card shadow-lg border-0 rounded-4 animate__animated animate__fadeInUp">
          <div className="card-body">
            <DataTable columns={columns} data={filteredContracts} pagination highlightOnHover pointerOnHover progressPending={loading} responsive fixedHeader fixedHeaderScrollHeight="60vh" noHeader customStyles={customStyles} />
          </div>
        </div>

        {/* modal */}
        <Modal show={showModal} onHide={closeModal} size="xl" animation>
          <Modal.Header closeButton className="bg-danger text-white" >
            <Modal.Title style={{ color: "white" }} ><i className="bi bi-journal-text me-2"></i> Contrato ID: {selectedContract?.id}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="animate__animated animate__fadeIn" >
             <div className="row">
              {/* Sidebar */}
              <div className="col-md-4">
                <form onSubmit={handleSubmit}>
                  <div className="card p-3 shadow-lg border-0 rounded-4">
                    {/* Nome do contrato */}
                    <div className="card p-3 shadow-lg border-0 rounded-4 mb-4">
                      <h5 className="fw-bold mb-2 " style={{ color: "#5dade2" }}>
                        <i className="bi bi-file-text me-2"></i> Nome do contrato
                      </h5>
                      <input
                        type="text"
                        className="form-control mb-3"
                        value={selectedContract?.name || ""}
                        onChange={(e) =>
                          setSelectedContract((prev) =>
                            prev ? { ...prev, name: e.target.value } : prev
                          )
                        }
                        placeholder="Digite o nome do contrato"
                      />
                    </div>


                     {/* Classificação (manual) */}
                  <h5 className="fw-bold mb-2 mt-3" style={{ color: "#5dade2" }}>
                    <i className="bi bi-diagram-3 me-2"></i> Classificação
                  </h5>
                  <select
                    className="form-select mb-3"
                    value={classification}
                    onChange={e => setClassification(e.target.value)}
                  >
                    <option value="">-- Selecione a classificação --</option>
                    {classificationOptions.map((c, idx) => (
                      <option key={idx} value={c}>{c}</option>
                    ))}
                  </select>



                    {/* Signatários */}
                   {/* <h5 className="fw-bold mb-3 " style={{ color: "#5dade2" }}>
                      <i className="bi bi-people me-2"></i> Signatários
                    </h5>
                    <div className="mb-3">
                      <div className="mb-2">
                        <SignatoriesStack signatories={signatories} />
                      </div>
                      {signatories.map((s, idx) => (
                        <div key={idx} className="input-group mb-2">
                          <input
                            type="email"
                            className="form-control"
                            value={s.email}
                            onChange={(e) => handleSignatoryChange(idx, e.target.value)}
                            placeholder="email@exemplo.com"
                          />
                          <select
                            className="form-select"
                            value={s.user_id ?? ""}
                            onChange={(e) =>
                              selectUserAsSignatory(
                                idx,
                                e.target.value ? Number(e.target.value) : null
                              )
                            }
                            title="Escolha usuário para preencher email automaticamente"
                          >
                            <option value="">— selecionar usuário —</option>
                            {users.map((u) => (
                              <option key={u.id} value={u.id}>
                                {u.name} — {u.email}
                              </option>
                            ))}
                          </select>
                          {signatories.length > 1 && (
                            <button
                              type="button"
                              className="btn"
                              style={{
                                backgroundColor: "#e74c3c",
                                borderColor: "#e74c3c",
                                color: "#fff",
                              }}
                              onClick={() => handleRemoveSignatory(idx, s.id)}
                            >
                              <i className="bi bi-trash" style={{ color: "#fff" }}></i>
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn w-100 mb-3"
                        style={{
                          backgroundColor: "#e74c3c",
                          borderColor: "#e74c3c",
                          color: "#fff",
                        }}
                        onClick={handleAddSignatory}
                      >
                        <i className="bi bi-plus-circle" style={{ color: "#fff" }}></i> 
                        Adicionar
                      </button>
                    </div>*/}

                      {/* Usuários (react-select com typeofcontract destacado) */}
               <h5 className="fw-bold mb-2" style={{ color: "#5dade2" }}>
          <i className="bi bi-people me-2"></i> Signatários
        </h5>

        <Select
          options={userOptions}
          isMulti
          placeholder="Selecione um ou mais usuários..."
          value={signatories.map(s =>
            userOptions.find(u => u.value === s.user_id)
          )}
          onChange={(selected, actionMeta) => {
            const selectedArray = Array.isArray(selected) ? selected : [];

            // 👉 CLICOU NO X (remover item)
            if (actionMeta?.action === "remove-value") {
              const removedUserId = actionMeta.removedValue?.value;

              const index = signatories.findIndex(
                s => s.user_id === removedUserId
              );

              if (index !== -1) {
                handleRemoveSignatory(index, signatories[index]?.id);
              }
            }

            // 👉 Atualiza estado com os selecionados atuais
            setSignatories(
              selectedArray.map(u => ({
                user_id: u.value,
                email: u.email,
                id: signatories.find(s => s.user_id === u.value)?.id
              }))
            );
          }}
          className="mb-3"
          components={{
            Option: CustomOption as any,
            MultiValue: CustomMultiValue as any
          }}
          styles={selectStyles}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
        />


                    {/* Hierarquia Empresa → Região → Unidade → Local */}
                    <h5 className="fw-bold mb-2" style={{ color: "#5dade2" }}>
                      <i className="bi bi-building me-2"></i> Empresa
                    </h5>
                    <select
                      className="form-select mb-3"
                      value={selectedCompany ?? ""}
                      onChange={(e) => {
                        const val = Number(e.target.value);
                        setSelectedCompany(val);
                        setSelectedRegion(null);
                        setSelectedUnit(null);
                        setSelectedLocation(null);
                      }}
                    >
                      <option value="">— Selecione empresa —</option>
                      {companies.map((c) => (
                        <option key={c.company_id} value={c.company_id}>
                          {c.name_company}
                        </option>
                      ))}
                    </select>

                    <h5 className="fw-bold mb-2" style={{ color: "#5dade2" }}>
                      <i className="bi bi-geo me-2"></i> Região
                    </h5>
                    <select
                      className="form-select mb-3"
                      value={selectedRegion ?? ""}
                      onChange={(e) => {
                        const val = Number(e.target.value);
                        setSelectedRegion(val);
                        setSelectedUnit(null);
                        setSelectedLocation(null);
                      }}
                      disabled={!selectedCompany}
                    >
                      <option value="">— Selecione região —</option>
                      {companies
                        .filter((c) => c.company_id === selectedCompany)
                        .map((c) => ({ region_id: c.region_id, region_name: c.region_name }))
                        .map((r, idx) => (
                          <option key={idx} value={r.region_id}>
                            {r.region_name}
                          </option>
                        ))}
                    </select>

                    <h5 className="fw-bold mb-2" style={{ color: "#5dade2" }}>
                      <i className="bi bi-building me-2"></i> Unidade
                    </h5>
                    <select
                      className="form-select mb-3"
                      value={selectedUnit ?? ""}
                      onChange={(e) => {
                        const val = Number(e.target.value);
                        setSelectedUnit(val);
                        setSelectedLocation(null);
                      }}
                      disabled={!selectedRegion}
                    >
                      <option value="">— Selecione unidade —</option>
                      {companies
                        .filter(
                          (c) =>
                            c.company_id === selectedCompany && c.region_id === selectedRegion
                        )
                        .map((c) => ({ unit_id: c.unit_id, unit_name: c.unit_name }))
                        .map((u, idx) => (
                          <option key={idx} value={u.unit_id}>
                            {u.unit_name}
                          </option>
                        ))}
                    </select>

                  {/** <h5 className="fw-bold mb-2" style={{ color: "#5dade2" }}>
                      <i className="bi bi-geo-alt me-2"></i> Local
                    </h5> 
                  
                    <select
                      className="form-select mb-4"
                      value={selectedLocation ?? ""}
                      onChange={(e) => setSelectedLocation(Number(e.target.value))}
                      disabled={!selectedUnit}
                    >
                      <option value="">— Selecione local —</option>
                      {companies
                        .filter(
                          (c) =>
                            c.company_id === selectedCompany &&
                            c.region_id === selectedRegion &&
                            c.unit_id === selectedUnit
                        )
                        .map((c) => ({ location_id: c.location_id, location_name: c.location_name }))
                        .map((l, idx) => (
                          <option key={idx} value={l.location_id}>
                            {l.location_name}
                          </option>
                        ))}
                    </select>
                    */}
                    

                    {/* Vencimento */}
                    <h5 className="fw-bold mb-2" style={{ color: "#5dade2" }}>
                      <i className="bi bi-calendar-event me-2"></i> Vencimento
                    </h5>
                    <input
                      type="date"
                      className="form-control mb-3"
                      value={dueDate}
                      onChange={(e) => setDueDate(e.target.value)}
                    />

                    {/* Lembretes<h5 className="fw-bold mb-2 g" style={{ color: "#5dade2" }}>
                      <i className="bi bi-bell me-2"></i> Lembretes
                    </h5>  <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={sms}
                        onChange={() => setSms(!sms)}
                      />
                      <label className="form-check-label">SMS</label>
                    </div> <div className="form-check mb-3">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={email}
                        onChange={() => setEmail(!email)}
                      />
                      <label className="form-check-label">Email</label>
                    </div> <input
                      type="text"
                      placeholder="Mensagem de notificação"
                      value={message}
                      name="message"
                      className="form-control mb-3"
                      onChange={(e) => setMessage(e.target.value)}
                    />
            */}
                    
                      {/* Reminder days */}
                      <h6 className="fw-bold text-secondary mb-2">Lembrete (dias)</h6>
                      <input
                        type="number"
                        className="form-control mb-4"
                        min={1}
                        value={reminderDays}
                        onChange={e => setReminderDays(Number(e.target.value))}
                      />


                    
                    {/* Documento */}
                    <h6>
                      <i className="bi bi-upload" style={{ color: "#5dade2" }}></i> 
                      Documento
                    </h6>
                    <input type="file" className="form-control mb-3" onChange={handleFileChange} />

                    {/* Botão Atualizar */}
                    <button
                      type="submit"
                      className="btn w-100"
                                           style={{background:"#5dade2", color:"white"}}

                    >
                      <i className="bi bi-check-circle" style={{ color: "#fff" }}></i> Atualizar
                    </button>
                  </div>
                </form>
              </div>

              {/* Preview + Histórico */}
              <div className="col-md-8">
                <div className="card shadow-lg border-0 rounded-4 mb-3" style={{ height: "60vh" }}>
                  {previewUrl ? (
                    <iframe
                      src={previewUrl}
                      style={{ width: "100%", height: "100%", border: "none", borderRadius: "12px" }}
                      title="preview"
                    />
                  ) : (
                    <div className="d-flex justify-content-center align-items-center h-100 text-muted">
                      <i className="bi bi-file-earmark-arrow-up display-1" style={{ color: "#5dade2" }}></i>
                    </div>
                  )}
                </div>

                <div className="card shadow-sm p-3 border-0 rounded-4" style={{ maxHeight: "20vh", overflowY: "auto" }}>
                  <h6 className="fw-bold" style={{ color: "#5dade2" }}>
                    <i className="bi bi-clock-history me-2"></i> Histórico
                  </h6>
                  {selectedContract?.history?.length ? (
                    selectedContract.history.map((h) => (
                      <div key={h.id} className="d-flex justify-content-between align-items-center border-bottom py-1">
                        <div>
                          <small className="text-muted">Criado em: {
                            h.created_at
                              ? new Date(h.created_at).toLocaleString("pt-BR", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })
                              : "-"
                          }
                          </small>
                        </div>
                        {h.caminho_doc ? (
                          <button
                            className="btn"
                                                 style={{background:"#5dade2", color:"white"}}

                            onClick={() => handlePreviewHistory(h)}
                          >
                            <i className="bi bi-eye" style={{ color: "#fff" }}></i> Ver
                          </button>
                        ) : (
                          <span className="text-muted">Indisponível</span>
                        )}
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">Nenhum histórico</p>
                  )}
                </div>
              </div>
              </div>
          </Modal.Body>
        </Modal>


      </div>
    </LayoutSubmasterToUser>
  );

}
